var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / Mapicons / ziel@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6860255,3.29173369 C8.30793788,3.29173369 7.16978826,2.39722529 5.43716846,2.39722529 C4.79540504,2.39722529 4.22053108,2.50996786 3.68726696,2.70616153 C3.76117124,2.51314958 3.79262502,2.30648086 3.7794875,2.10022165 C3.73391728,1.36893795 3.13443232,0.782362844 2.40232569,0.752582758 C1.57956723,0.719099449 0.902057423,1.37616438 0.902057423,2.19149067 C0.902057423,2.68077903 1.14629013,3.11279601 1.51926127,3.3730503 L1.51926127,13.30116 C1.51926127,13.6420366 1.79558858,13.9183639 2.13646513,13.9183639 L2.54793436,13.9183639 C2.88881091,13.9183639 3.16513821,13.6420366 3.16513821,13.30116 L3.16513821,10.8734915 C3.89320731,10.5632437 4.80026552,10.3045839 6.10804333,10.3045839 C7.48615667,10.3045839 8.62428057,11.1990923 10.3569004,11.1990923 C11.5956542,11.1990923 12.5857006,10.7800623 13.5073403,10.1483541 C13.7306395,9.99531331 13.8633383,9.74120534 13.8633383,9.47051002 L13.8633383,3.21874933 C13.8633383,2.6171556 13.2392166,2.21913626 12.6936084,2.47254988 C11.810544,2.88268184 10.7274541,3.29173369 9.6860255,3.29173369 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(5.117302, 5.165139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.117302, -5.165139)",
    id: "Color-/-Secondary-/-Hover"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#394854",
    x: 0,
    y: 0,
    width: 34.2,
    height: 34.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.25bb58854cbd3d8361d692af8897c8a6.svg";
export { ForwardRef as ReactComponent };